/**
 * Human duration label ("N days" / "N months") built from rent.daysUntil.*
 * keys, rounding to months from 30 days. Shared by the rentals list badge
 * and the rental detail header (total/remaining duration).
 */
export function durationLabel(
	days: number,
	t: (key: string, opts?: Record<string, unknown>) => string,
): string {
	if (days >= 60) return t('rent.daysUntil.months', { count: Math.round(days / 30) })
	if (days >= 30) return t('rent.daysUntil.month', { count: Math.round(days / 30) })
	return t('rent.daysUntil.days', { count: days })
}
